const contactDetails = [
  { label: 'Email', value: 'harsht7874@gmail.com', href: 'mailto:harsht7874@gmail.com' },
  { label: 'Phone', value: '+44 7440 770072', href: 'tel:+447440770072' },
  { label: 'Location', value: 'Cheylesmore, Coventry, UK' },
  {
    label: 'LinkedIn',
    value: 'linkedin.com/in/harshbtrivedi',
    href: 'https://www.linkedin.com/in/harshbtrivedi/'
  },
  { label: 'GitHub', value: 'github.com/harrytrivedi', href: 'https://github.com/harrytrivedi' }
];

export default function Contact() {
  return (
    <div id="contact" className="govuk-width-container govuk-!-padding-top-8 govuk-!-padding-bottom-8">
      <h2 className="govuk-heading-l">Get in touch</h2>
      <div className="govuk-grid-row">
        <div className="govuk-grid-column-two-thirds">
          <p className="govuk-body">
            I'm always open to conversations about public sector digital transformation,
            accessible service design, or project delivery roles and collaborations.
            The quickest ways to reach me are below.
          </p>
          <dl className="govuk-summary-list">
            {contactDetails.map((d) => (
              <div className="govuk-summary-list__row" key={d.label}>
                <dt className="govuk-summary-list__key">{d.label}</dt>
                <dd className="govuk-summary-list__value">
                  {d.href ? (
                    <a
                      className="govuk-link"
                      href={d.href}
                      target={d.href.startsWith('http') ? '_blank' : undefined}
                      rel="noopener noreferrer"
                    >
                      {d.value}
                    </a>
                  ) : (
                    d.value
                  )}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
